import { render } from "./FriedRiceView.vue?vue&type=template&id=c16f261e"
import script from "./FriedRiceView.vue?vue&type=script&lang=js"
export * from "./FriedRiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__